import React from 'react';
import classnames from 'classnames';
import { get, map, slice, size, ceil, times, filter, includes, fromPairs, isEmpty, isEqual, isNil, find, findIndex } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { getLabel } from 'utils/getLabel';
import { getDisplayValue } from 'resolvers/formatValue';
import { DATA_TYPES, GLOBAL_LABELS } from 'constants/common';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { MapWithStores } from 'ui/containers/MapWithStores';
import { spinner as Spinner } from 'ui/views/generic/spinner';
import { buttonPreloader as ButtonPreloader } from 'ui/views/generic/buttonPreloader';

// import { button as Button } from 'mod ules/button';

/*******************************/

// success view
export const drugPricingPharmacyLocatorSuccess = ( props ) => {

    // extract values from the component data
    const filtersTitle = get( props.filtersConfig, 'title', {} );
    const filterFields = get( props.filtersConfig, 'fields', [] );
    const mailOrderPharmacyTitle = get( props.locationsConfig, 'mailOrderPharmacy.title', {} );
    const mailOrderPharmacySubTitle = get( props.locationsConfig, 'mailOrderPharmacy.subtitle', {} );
    const mailOrderPharmacyFields = get( props.locationsConfig, 'mailOrderPharmacy.fields', [] );
    const retailPharmaciesTitle = get( props.locationsConfig, 'retailPharmacies.title', {} );
    const retailPharmaciesFields = get( props.locationsConfig, 'retailPharmacies.fields', [] );
    const retailPharmaciesActions = get( props.locationsConfig, 'retailPharmacies.actions', [] );


    // location pages (for pagination)
    const locationsPages = ceil( size( props.retailPharmacies ) / props.locationsPerPage );
    const retailPharmacies = slice( props.retailPharmacies, ( ( props.currentPage - 1 ) * props.locationsPerPage ), ( ( props.currentPage ) * props.locationsPerPage ) );

    const fetchDrugPriceAction = find( retailPharmaciesActions, { name: 'fetchDrugPrice' } );

    return (
        <div className='ui-drug-pricing-pharmacy-locator'>
            {/* title */}
            <div className='ui-drug-pricing-pharmacy-locator__title'>
                { getLabel( props.widgetTitle ) }
            </div>

            {/* filters */}
            <div className='ui-drug-pricing-pharmacy-locator__filters'>
                <div className='ui-drug-pricing-pharmacy-locator__filters__title'>
                    { getLabel( filtersTitle ) }
                </div>

                <div className='ui-drug-pricing-pharmacy-locator__filters__fields'>
                    <Form
                        fields = { fromPairs( map( filterFields, field => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                        values = { props.filters } // default values
                        onSubmit = { ( { values, isValid } ) => {

                            if( isValid && ! isEqual( props.filters, values ) ) {
                                props.onFiltersChange( values );
                            }
                        } }
                    >
                        {
                            ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {
                                return (

                                        <div className='ui-drug-pricing-pharmacy-locator__filters__fields__inputs'>
                                            {
                                                map( fields, ( field ) => {

                                                    // field class name
                                                    const fieldClassName = classnames( 'ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field', {
                                                        'ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field--error': ! isEmpty( get( errors, field.name, null ) ),
                                                    } );
                
                                                    return (
                                                        <div key={ field.name } className={ fieldClassName }>
                                                            <div className='ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field__input'>
                                                                <input
                                                                    type='text'
                                                                    className='ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field__input__control'
                                                                    required={ field.required }
                                                                    value={ values[ field.name ] }
                                                                    onChange={ ( e ) => onChange( { name: field.name, value: e.target.value } ) }
                                                                    onBlur={ () => onSumbit() }
                                                                />
                
                                                                <div className='ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field__input__icon'>
                                                                    <Icon name='edit' width='12' height='12'/>
                                                                </div>
                                                            </div>
                
                                                            <div className='ui-drug-pricing-pharmacy-locator__filters__fields__inputs__field__label'>
                                                                { getLabel( field.title ) }{ 'distance' === field.name ? ',' : '' }
                                                            </div>
                                                        </div>
                                                    );
                                                } )
                                            }
                                        </div>

                        
                                );
                            }
                        }
                    </Form>
                </div>

                {/* spinner */}
                {
                    props.isFetchingLocations ? (
                        <div className='ui-drug-pricing-pharmacy-locator__filters__spinner'>
                            <Spinner />
                        </div>
                    ): null
                }
            </div>

            {/* locations */}
            <div className='ui-drug-pricing-pharmacy-locator__locations'>
                {/* map */}
                {
                    isEmpty( retailPharmacies ) ? (
                        <div className='ui-drug-pricing-pharmacy-locator__locations__map-section'>
                            <div className='ui-drug-pricing-pharmacy-locator__locations__map-section__map ui-drug-pricing-pharmacy-locator__locations__map-section__map--no-data'></div>
                        </div>
                    ) : (
                        <MapWithStores
                            id={ props.mapId }
                            className='ui-drug-pricing-pharmacy-locator__locations__map-section'
                            mapClassName='ui-drug-pricing-pharmacy-locator__locations__map-section__map'
                            locations={ retailPharmacies }
                        />
                    )
                }

                {/* pharmacies */}
                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies'>

                    {/* Mail order pharmacy */}
                    {
                        isEmpty( props.mailOrderPharmacy ) ? null : (
                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order'>
                                {/* title */}
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__title'>
                                    { getLabel( mailOrderPharmacyTitle ) }
                                </div>

                                {/* subtitle */}
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__subtitle'>
                                    { getLabel( mailOrderPharmacySubTitle, { days: props.mailOrderPharmacy.supplyDays } ) }
                                </div>

                                {/* divider */}
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__divider'></div>

                                {/* pharmacy info */}
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info'>
                                    {/* left panel */}
                                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__left'>
                                        {/* title */}
                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__left__title'>
                                            { props.mailOrderPharmacy.name }
                                        </div>

                                        {/* address */}
                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__left__address'>
                                            <Icon name='location'/>
                                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__left__address__text'>
                                                { getDisplayValue( { type: DATA_TYPES.ADDRESS, value: props.mailOrderPharmacy.address, returnType: DATA_TYPES.TEXT } ) }
                                            </div>
                                        </div>
                                    </div>
                                    

                                    {/* right panel */}
                                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__right'>
                                        
                                        {
                                            map( filter( mailOrderPharmacyFields, _field => includes( [ 'totalCost', 'perDayCost' ], _field.name ) ), field => {
                                                return (
                                                    <div key={ field.name } className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__right__field'>
                                                        {/* label */}
                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__right__field__label'>
                                                            { 'totalCost' === field.name ? `${ get( props.mailOrderPharmacy, `${ field.name }.days` ) } ${ getLabel( field.title ) }`: getLabel( field.title ) }
                                                        </div>

                                                        {/* value */}
                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__mail-order__pharmacy-info__right__field__value'>
                                                        { getDisplayValue( { type: field.type, value: get( props.mailOrderPharmacy, `${ field.name }.value` ) } ) }
                                                        </div>
                                                    </div>
                                                );
                                            } )
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {/* retail pharmacies */}
                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail'>
                        {/* title */}
                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__title'>
                            { getLabel( retailPharmaciesTitle ) }
                        </div>

                        {/* items */}
                        {
                            isEmpty( retailPharmacies ) ? (
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items'>
                                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__error'>
                                        {
                                            getLabel( GLOBAL_LABELS.DISPLAY_TEXT_NO_MATCH_FOUND )
                                        }
                                    </div>
                                </div>
                            ) : (
                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items'>
                                    {
                                        map( retailPharmacies, retailPharmacy => {

                                            // pharmacy location class name
                                            const pharmacyClassName = classnames( 'ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item', {
                                                'ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item--selected': props.selectedLocation === retailPharmacy.id,
                                            } );

                                            const drugInfoFields = map( filter( retailPharmaciesFields, _field => includes( [ 'totalCost', 'perDayCost' ], _field.name ) ), field => {
                                                return field;
                                            } );

                                            const isValueAvailable = ! isNil( get( retailPharmacy, 'totalCost' ) ) && ! isNil( get( retailPharmacy, 'perDayCost' ) );
                                            const isFetching = -1 !== findIndex( props.requestedDrugPricingId, function( o ) { return o === retailPharmacy.id; } );

                                            return (
                                                <div key={ retailPharmacy.id } className={ pharmacyClassName } onClick={ () => props.onLocationSelect( retailPharmacy.id ) }>

                                                    {/* left panel */}
                                                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left'>
                                                        {/* title */}
                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__title'>
                                                            { retailPharmacy.name }
                                                        </div>

                                                        {/* address */}
                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__address'>
                                                            <Icon name='location'/>
                                                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__address__text'>
                                                                { getDisplayValue( { type: DATA_TYPES.ADDRESS, value: retailPharmacy.address, returnType: DATA_TYPES.TEXT } ) }
                                                            </div>
                                                        </div>

                                                        {/* phone and miles */}
                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__phone-and-miles'>
                                                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__phone-and-miles__phone'>
                                                                <Icon name='phone' width='13' height='13' fill='#000'/>
                                                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__phone-and-miles__phone__text'>{ retailPharmacy.phone }</div>
                                                            </div>
                                                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__phone-and-miles__miles'>
                                                                <Icon name='distance'/>
                                                                <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__left__phone-and-miles__miles__text'>
                                                                    { getDisplayValue( { type: DATA_TYPES.DISTANCE, value: retailPharmacy.distance, options: get( props, 'options.distanceType', [] ) } ) }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    

                                                    {/* right panel */}
                                                    <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__right'>
                                                        {
                                                            isValueAvailable && map( drugInfoFields, field => {
                                                                return (
                                                                    <div key={ field.name } className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__right__field'>
                                                                        {/* label */}
                                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__right__field__label'>
                                                                            { 'totalCost' === field.name ? `${ get( retailPharmacy, `${ field.name }.days` ) } ${ getLabel( field.title ) }`: getLabel( field.title ) }
                                                                        </div>

                                                                        {/* value */}
                                                                        <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__right__field__value'>
                                                                        { getDisplayValue( { type: field.type, value: get( retailPharmacy, `${ field.name }.value` ) } ) }
                                                                        </div>
                                                                    </div>
                                                                );
                                                            } )
                                                        }

                                                        { ! isValueAvailable && (
                                                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__retail__items__item__right__action' onClick={ () => props.fetchDrugPrice( retailPharmacy ) }>
                                                               { isFetching ? (
                                                                   <ButtonPreloader />
                                                               ) : (
                                                                    getLabel( fetchDrugPriceAction.title )
                                                               ) }
                                                            </div>
                                                        ) }
                                                    </div>
                                                </div>
                                            );
                                        } )
                                    }
                                </div>
                            )
                        }
                    </div>


                    {/* pagination */}
                    {
                        1 < locationsPages ? (
                            <div className='ui-drug-pricing-pharmacy-locator__locations__pharmacies__pagination'>
                                {
                                    times( locationsPages, index => {

                                        // pagination item class name
                                        const paginationItemClass = classnames( 'ui-drug-pricing-pharmacy-locator__locations__pharmacies__pagination__item', {
                                            'ui-drug-pricing-pharmacy-locator__locations__pharmacies__pagination__item--selected': props.currentPage - 1 === index,
                                        } );

                                        return (
                                            <div key={ index } className={ paginationItemClass } onClick={ () => props.onActivateLocationsPage( index + 1 ) } >
                                                { index + 1 }
                                            </div>
                                        );
                                    } )
                                }
                            </div>
                        ) : null
                    }
                </div>
            </div>

        </div>
    );
};

// set display name
drugPricingPharmacyLocatorSuccess.displayName = 'drugPricingPharmacyLocatorSuccess';

// set default props
drugPricingPharmacyLocatorSuccess.defaultProps = {
    isFetchingLocations: false,
};

// prop types
drugPricingPharmacyLocatorSuccess.propTypes = {};

/*******************************/

// preloader view
export const drugPricingPharmacyLocatorPreloader = () => {
    return (
        <div className='ui-drug-pricing-pharmacy-locator-preloader'>
            <div className='ui-drug-pricing-pharmacy-locator-preloader__title'></div>
            <div className='ui-drug-pricing-pharmacy-locator-preloader__filters'></div>
            <div className='ui-drug-pricing-pharmacy-locator-preloader__locations'>
                <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__map'></div>
                <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies'>
                    <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies__title'></div>
                    <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies__pharmacy'></div>
                    <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies__pharmacy'></div>
                    <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies__pharmacy'></div>
                    <div className='ui-drug-pricing-pharmacy-locator-preloader__locations__pharmacies__pharmacy'></div>
                </div>
            </div>
        </div>
    );
};

// set display name
drugPricingPharmacyLocatorPreloader.displayName = 'drugPricingPharmacyLocatorPreloader';

// set default props
drugPricingPharmacyLocatorPreloader.defaultProps = {};

// prop types
drugPricingPharmacyLocatorPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { drugPricingPharmacyLocator as DrugPricingPharmacyLocator } from 'ui/views/widgets/drugPricingPharmacyLocator';
 *
 * // render
 * <DrugPricingPharmacyLocator propName='propValue'/>
 */
export const drugPricingPharmacyLocator = withNetworkState( drugPricingPharmacyLocatorPreloader, drugPricingPharmacyLocatorSuccess );
